var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndentButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.35351 2.64645C3.15825 2.45118 2.84167 2.45118 2.64641 2.64645C2.45115 2.84171 2.45115 3.15829 2.64641 3.35355L4.29285 5L2.64641 6.64645C2.45115 6.84171 2.45115 7.15829 2.64641 7.35355C2.84167 7.54882 3.15825 7.54882 3.35351 7.35355L5.35351 5.35355C5.54878 5.15829 5.54878 4.84171 5.35351 4.64645L3.35351 2.64645Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.99964C7.22386 2.99964 7 3.2235 7 3.49964C7 3.77578 7.22386 3.99964 7.5 3.99964H13.5C13.7761 3.99964 14 3.77578 14 3.49964C14 3.2235 13.7761 2.99964 13.5 2.99964H7.5Z",
    fill: "#585858"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5.99964C7.22386 5.99964 7 6.2235 7 6.49964C7 6.77578 7.22386 6.99964 7.5 6.99964H13.5C13.7761 6.99964 14 6.77578 14 6.49964C14 6.2235 13.7761 5.99964 13.5 5.99964H7.5Z",
    fill: "#585858"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 8.99964C2.22386 8.99964 2 9.2235 2 9.49964C2 9.77578 2.22386 9.99964 2.5 9.99964H13.5C13.7761 9.99964 14 9.77578 14 9.49964C14 9.2235 13.7761 8.99964 13.5 8.99964H2.5Z",
    fill: "#585858"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 11.9996C2.22386 11.9996 2 12.2235 2 12.4996C2 12.7758 2.22386 12.9996 2.5 12.9996H13.5C13.7761 12.9996 14 12.7758 14 12.4996C14 12.2235 13.7761 11.9996 13.5 11.9996H2.5Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndentButton);
export default __webpack_public_path__ + "static/media/indentButton.4bf73136e33cbeaaabe8ce61c4f9dc25.svg";
export { ForwardRef as ReactComponent };